import axios from "axios";
import { hasValue } from "../utils/commonFns";
import AppConfig from "../config";

const baseURL = `${AppConfig.API_URL}/Vendor`;

const getVendors = async (
  nameFilter,
  submissionStatusFilter,
  submittedDueByType,
  dateRangeFilter
) => {
  try {
    var url = `${baseURL}?`;

    if (hasValue(nameFilter)) url += `name=${nameFilter}&`;

    if (hasValue(submissionStatusFilter))
      url += `submissionStatus=${submissionStatusFilter}&`;

    if (hasValue(submittedDueByType))
      url += `submittedDueByType=${submittedDueByType}&`;
    if (hasValue(dateRangeFilter)) url += `dateRangeFilter=${dateRangeFilter}`;

    let { data } = await axios.get(url);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const getVendorById = async (vendorId) => {
  try {
    let { data } = await axios.get(`${baseURL}/${vendorId}`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const saveVendor = async (vendor) => {
  try {
    // let { data } = await axios.post(`${baseURL}`, JSON.stringify(vendor));

    let { data } = await axios.post(`${baseURL}`, vendor, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.success;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const updateVendor = async (vendor) => {
  try {
    // let { data } = await axios.put(`${baseURL}`, JSON.stringify(vendor));

    let { data } = await axios.put(`${baseURL}`, vendor, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (data.success) {
      return data.success;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const importVendors = async (requestBody) => {
  try {
    let { data } = await axios.post(
      `${AppConfig.LAMBDA_URL}/Vendor/import`,
      requestBody,
      {
        timeout: 300000,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export { getVendors, getVendorById, saveVendor, updateVendor, importVendors };
